export default "__VITE_ASSET__c71291a3__"